import './williamsonthelake/style';
import FormStructure from './williamsonthelake/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js